var exports = {
  "zr": "RoomOutfitEditor.module__root___ZHkzNW",
  "EN": "RoomOutfitEditor.module__editor___ZHkzNW",
  "VD": "RoomOutfitEditor.module__stageColumn___ZHkzNW",
  "dx": "RoomOutfitEditor.module__looks___ZHkzNW",
  "dI": "RoomOutfitEditor.module__wardrobe___ZHkzNW",
  "R_": "RoomOutfitEditor.module__heading___ZHkzNW",
  "dw": "RoomOutfitEditor.module__stage___ZHkzNW",
  "XE": "RoomOutfitEditor.module__stageLight___ZHkzNW",
  "ou": "RoomOutfitEditor.module__stageImage___ZHkzNW",
  "iH": "RoomOutfitEditor.module__stage3d___ZHkzNW",
  "FC": "RoomOutfitEditor.module__stageCaption___ZHkzNW",
  "YA": "RoomOutfitEditor.module__lookRow___ZHkzNW",
  "Op": "RoomOutfitEditor.module__look___ZHkzNW",
  "Vd": "RoomOutfitEditor.module__lookImage___ZHkzNW",
  "vR": "RoomOutfitEditor.module__tabs___ZHkzNW",
  "Mf": "RoomOutfitEditor.module__tab___ZHkzNW",
  "o5": "RoomOutfitEditor.module__tabThumb___ZHkzNW",
  "Gn": "RoomOutfitEditor.module__tabLabel___ZHkzNW",
  "Vg": "RoomOutfitEditor.module__grid___ZHkzNW",
  "Vs": "RoomOutfitEditor.module__tile___ZHkzNW",
  "uP": "RoomOutfitEditor.module__tileImage___ZHkzNW",
  "xt": "RoomOutfitEditor.module__locked___ZHkzNW",
  "Wn": "RoomOutfitEditor.module__noneIcon___ZHkzNW",
  "wH": "RoomOutfitEditor.module__selected___ZHkzNW",
  "O3": "RoomOutfitEditor.module__checkBadge___ZHkzNW",
  "NE": "RoomOutfitEditor.module__lockBadge___ZHkzNW",
  "$7": "RoomOutfitEditor.module__sentinel___ZHkzNW",
  "dU": "RoomOutfitEditor.module__colour___ZHkzNW",
  "zz": "RoomOutfitEditor.module__swatches___ZHkzNW",
  "nf": "RoomOutfitEditor.module__swatch___ZHkzNW",
  "Rj": "RoomOutfitEditor.module__lockedNotice___ZHkzNW",
  "o1": "RoomOutfitEditor.module__actions___ZHkzNW",
  "g5": "RoomOutfitEditor.module__lockedText___ZHkzNW",
};

module.exports = exports;
